export default "/_next/static/images/ae421ef169f740ce4b7fc3c6919a8060.png";